import isAvailable from "./isAvailable";

const isPaymentActive = (inventory: any, isBookFormEnabledForInactiveProperty = false) => {
  let flag = isAvailable(inventory) || isBookFormEnabledForInactiveProperty;
  if (inventory?.meta?.payment == false) {
    flag = false;
  }
  return flag;
};

export default isPaymentActive;
